import { get, post, upload } from "./service";
//精确查询 根据标题查询
// export default {
//   // post p=>data   get p=>params
//   test: p => post("", p),
//   test1: p => get("", p),
//   //论文检索
//   manyElements: p => post("/api/getCore/manyElements", p),
//   // 导出为pdf iframe打开
//   pdf: (id) => { return (process.env.VUE_APP_API_URL + 'getCore/viewCore?id=' + id + '&loginName=' + (sessionStorage.getItem('hospitalName') ? sessionStorage.getItem('hospitalName') : '')) },
//   //下载全文pdf
//   downloadCore: id => window.open(process.env.VUE_APP_API_URL + 'getCore/downloadCore?id=' + id + "&loginName=" + (sessionStorage.getItem('hospitalName') ? sessionStorage.getItem('hospitalName') : '')),


//   // downloadCore:id => window.open(process.env.VUE_APP_API_URL+'getCore/downloadCore?id='+id+"&loginName="+(sessionStorage.getItem('token')?sessionStorage.getItem('token'):'')),



//   //批量导出到txt
//   exportTxt: (idList, type) => window.open(process.env.VUE_APP_API_URL + 'getCore/exportTxt?idList=' + idList + '&type=' + type + "&loginName=" + (sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '')),
//   //论文详情
//   id: p => post("/api/getCore/id", p),
//   //中华医学会期刊查询
//   chineseNedicalAssociation: p => post("/api/getJournal/chineseNedicalAssociation", p),
//   //根据期刊id准确查询
//   getJournal: p => post("/api/getJournal/id", p),
//   //###根据期刊，对应年，对应期查询
//   JournalsInstallment: p => post("/api/getCore/JournalsInstallment", p),
//   //高级检索
//   advancedSearch: p => post("/api/getCore/advancedSearch", p),
//   //ip检查
//   institutions: p => post("/api/getCore/institutions", p),
//   //登录
//   appLogin: p => post("/api/getCore/pcLogin", p),

//   //期刊学科分类
//   perioSub: p => post("/api/getJournal/subject", p),
//   //合作站点
//   cooperator: p => post("/api/getCore/loginZSK", p),
// };
//文章类型
export const articleTypeList = () => get("/articleType/list")
//登录
export const login = p => post("/login", p)
// export function login(params) {
//   // 密码采用sm2加密传输密码
//   const sm2 = require('sm-crypto').sm2
//   const publicKey = '04298364ec840088475eae92a591e01284d1abefcda348b47eb324bb521bb03b0b2a5bc393f6b71dabb8f15c99a0050818b56b23f31743b93df9cf8948f15ddb54'
//   const encryptData = sm2.doEncrypt(params.password, publicKey, 1)
//   params.password = encryptData
//   post("/login", params)

// }
//用户信息
export const getUserInfo = () => get("/getLoginUser")
//文章列表
export const getIndexList = () => get("/article/index")
//文章详情
export const getArticleByIdList = (params) => get(`/article/articleById`, params)
// 我的信息
export const getNewsPage = (params) => get("/news/page", params)
// 我的收藏
export const getCollectionPage = (params) => get("/collection/page", params)
// 修改密码
export const updatePwd = (params) => post("/sysUser/updatePwd", params)
//二级分类
export const getArticleTypeSubList = (params) => get("/articleTypeThree/page", params)
//关键词
export const getArticleKeywordList = (params) => get("/articleKeyword/page", params)
//更多文章
export const getArticlePage = (params) => post("/article/articlePage", params)
//是否收藏
export const getCollectionExist = (contentId) => get(`/collection/exist?contentId=${contentId}`)
//资讯添加收藏
export const collectionAdd = (params) => post("/collection/add", params)
//资讯取消收藏
export const collectionDelete = (contentId) => post(`/collection/delete?contentId=${contentId}`,)
// 获取舆情列表
export const getOpinionList = (params) => get("/opinion/page", params)

export const addOpinion = (params) => post("/opinion/add", params)

//资料填报查询
export const getdataReviewItem = (params) => get("/dataReviewItem/page", params)
//查询专家
export const getSelectByName = (params) => get("/sysUser/pages", params)
//分配专家
export const dataCheckyAdd = (params) => post("/dataCheck/add", params)
//获取审批id
export const getDataCheckPage = (params) => get("/dataCheck/page", params)
//审批
export const dataCheckyEdit = (params) => post("/dataCheck/edit", params)
//查看
export const dataCheckyDetail = (id) => get(`/dataCheck/detail?id=${id}`,)
// 专家列表
// 名称模糊搜索
export const selectByName = (params) => get("/sysUser/selectByName", params)
// 新增专家
export const addExpert = (params) => get("/sysUser/updateById", params)
export const getExpertList = (params) => get("/sysUser/pages", params)
export const delExpert = (params) => post("/sysUser/deleteById", params)
export const editExpert = (params) => post("/sysUser/updateSysUserVo", params)
// 新增填报
export const addDataReview = (params) => post("/dataReview/add", params)
export const editDataReview = (params) => post("/dataReview/edit", params)
export const getDataReview = (params) => get("/dataReview/page", params)
export const delDataReview = (params) => post("/dataReview/delete", params)
export const getDataReviewItemAdd = (params) => post(`/dataReviewItem/add`, params)
//导出图表
export const dataReviewItemExport = (id) => get(`/dataReviewItem/export?dataId=${id}`)
//填报退回
export const getDataReviewItemDelete = (params) => post(`/dataReviewItem/delete`, params)
//文件预览
export const getSysFileInfoPreview = (id, responseType) => get(`/sysFileInfo/preview?id=${id}`, {}, responseType)
//文件删除
export const deleteSysFileInfo = (params) => post(`/sysFileInfo/deleteInvalid`, params)
//查询栏目
export const getPanelQueue = (params) => get(`/userArticleType/detail`, params)
//调整栏目顺序
export const editPanelQueue = (params) => post(`/userArticleType/edit`, params)
//添加默认的栏目顺序
export const addPanelQueue = (params) => post(`/userArticleType/add`, params)
export const getArticleKeyword = (params) => get(`/articleKeyword/treeList`, params)
// 获取关键字列表
export const getkeywordList = (params) => get(`/articleKeyword/list`, params)
// 删除文章关键字
export const deleteArticleKeyword = (params) => post(`/articleKeyword/delete`, params)
// 新增文章关键字
export const addArticleKeyword = (params) => post(`/articleKeyword/add`, params)
// 获取资讯列表
export const articlePageAdmin = (params) => post(`/article/articlePageAdmin`, params)
// 删除资讯
export const deleteSolr = (params) => get(`/article/deleteSolr`, params)
// 文章列表
export const articlePageAll = (params) => post(`/article/articlePageAll`, params)
// 删除文章
export const deleteArticle = (params) => post(`/article/delete`, params)
// 发布/撤回 文章
export const enableArticle = (params) => get(`/article/enable`, params)
// 修改文章
export const editArticle = (params) => post(`/article/edit`, params)
// 文章详情
export const getArticleDetail = (params) => get(`/article/detail`, params)

// 敏感词列表
export const articleSensitivePage = (params) => get(`/articleSensitive/page`, params)
// 新增敏感词
export const addArticleSensitive = (params) => post(`/articleSensitive/add`, params)
// 删除敏感词
export const deleteArticleSensitive = (params) => post(`/articleSensitive/delete`, params)
// 获取敏感词详情
export const getArticleSensitiveDetail = (params) => get(`/articleSensitive/detail`, params)
// 修改敏感词
export const editArticleSensitive = (params) => post(`/articleSensitive/edit`, params)
// 导入敏感词
export const importArticleSensitive = (params) => upload(`/articleSensitive/imports`, params)
// 获取用户列表
export const getUserPage = (params) => get(`/sysUser/page`, params)
// 获取角色列表
export const getRolePage = (params) => get(`/sysRole/page`, params)
// 删除用户
export const deleteUser = (params) => post(`/sysUser/delete`, params)
// 重置密码
export const resetPwd = (params) => post(`/sysUser/resetPwd`, params)
// 重置密码
export const editUser = (params) => post(`/sysUser/edit`, params)
// 添加文章
export const addArticle = (params) => post(`/article/add`, params)
// 添加用户
export const addUser = (params) => post('/sysUser/add', params)
// 获取角色详情
export const getUserDetail = (params) => get('/sysRole/detail', params)
// 获取角色菜单
export const getOwnMenu = (params) => get('/sysRole/ownMenu', params)
// 获取栏目列表
export const getArticleTypePage = (params) => get('/articleType/page', params)
// 获取医学前沿信息列表
export const getMedicalFrontiers = (params) => post('/MedicalFrontiers/article/page', params)
// 新增医学前沿信息列表
export const addMedicalFrontiers = (params) => post('/MedicalFrontiers/article/add', params)
// 删除医学前沿信息列表
export const deleteMedicalFrontiers = (params) => post('/MedicalFrontiers/article/delete', params)
// 修改医学前沿信息列表
export const updateMedicalFrontiers = (params) => post('/MedicalFrontiers/article/update', params)
// 获取医学前沿信息详情
export const getMedicalFrontiersDetail = (params) => get('/MedicalFrontiers/article/details', params)
// 获取医学前沿信息详情
export const uploadFile = (params) => upload('/sysFileInfo/upload', params)
// 上传图片
export const uploadCover = (params) => upload('/sysFileInfo/uploadCover', params)
// 获取轮播文章
export const getRotationAll = (params) => get('/rotation/all', params)
// 获取轮播文章详情
export const getRotationDetail = (params) => get('/rotation/detail', params)
// 修改轮播文章
export const updateRotation = (params) => post('/rotation/edit', params)

// 查询我的关注类别列表
export const getMyFollowType = (params) => get('/follow/myFollowType', params)

// 关注表_是否已关注
export const getExist = (params) => get('/follow/exist', params)

// 查询我的关注文章列表
export const postmyFollowPage = (params) => post('/follow/myFollowPage', params)

// 关注表_增加或者删除
export const postFollowAddOrDel = (params) => post('/follow/addOrDel', params)

// 查询表格数据
export const postSelectdataPooling = (params) => post('/dataPooling/select', params)
